import { DTIProps, EMessengerChatSourceType, IMessengerChatSource } from '@xometry/ui';
import { ReactComponent as MessengerIcon } from 'assets/icons/message-center-outlined.min.svg';
import cn from 'clsx';
import { amplitudeLogger } from 'common/amplitude';
import { AMPLITUDE_ATTRIBUTE_KEYS, MESSENGER_ENTRY_POINTS, MESSENGER_EVENTS } from 'common/enums/amplitudeEvents';
import { useOpenMessenger } from 'common/hooks/useOpenMessenger';
import { useCurrentProviderQuery } from 'graphql/queries/__generated__/currentProvider';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import s from './GeneralChatButton.module.less';

interface Props extends Partial<DTIProps> {
  entryPoint?: MESSENGER_ENTRY_POINTS;
  className?: string;
  title?: string;
  showIcon?: boolean;
}

export const GeneralChatButton: FC<Props> = (props) => {
  const { entryPoint, title, className, showIcon = true, 'data-testid': DTI = 'GeneralChatButton' } = props;
  const { t } = useTranslation();
  const { loading, data } = useCurrentProviderQuery({
    fetchPolicy: 'cache-and-network',
  });
  const openMessenger = useOpenMessenger();

  const { currentProvider } = data || {};

  const handleClick = () => {
    if (!currentProvider) {
      return;
    }

    const chatSource: IMessengerChatSource = {
      id: String(currentProvider.id),
      title: `${t('support.generalChat')}`,
      sourceType: EMessengerChatSourceType.PARTNER,
      sourceId: String(currentProvider.id),
    };

    openMessenger(chatSource);

    if (entryPoint) {
      amplitudeLogger(MESSENGER_EVENTS.MESSENGER_OPENED, {
        [AMPLITUDE_ATTRIBUTE_KEYS.ENTRY_POINT]: entryPoint,
        sourceType: EMessengerChatSourceType.PARTNER,
      });
    }
  };

  return (
    <button
      data-testid={DTI}
      className={cn(className, s.generalChatButton)}
      onClick={handleClick}
      disabled={loading || !currentProvider}
    >
      {showIcon ? <MessengerIcon /> : null}
      {title || t('support.generalChat')}
    </button>
  );
};
